export default {
  methods: {
      $email(){
          let email = this.$store.state.user.email;
          return email;
      }
  },
}
